import React from "react";
import { Box } from "@mui/material";
import { Query } from "system/query/Query";
import { QueryInfo } from "system/query/QueryInfo";
import QuerySegmentContainer from "./queryBuilder/common/QuerySegmentContainer";

export interface QueryViewerProps {
  query: Query;
  queryInfo: QueryInfo;
}

export default function QueryViewer(props: QueryViewerProps): JSX.Element {
  return (
    <Box sx={{ m:0, p:1, position:'relative', width:'100%' }}>
      {props.query.query && props.queryInfo &&
        <QuerySegmentContainer
          depth={0}
          path=""
          isViewerMode={true}
          queryInfo={props.queryInfo}
          originalQuery={props.query}
          querySegment={props.query.query} />
      }
      {/*Overlay to keep the user from being able to interact with the query*/}
      <Box sx={{position:'absolute', top:0, left:0, right:0, bottom:0, zIndex:300}} />
    </Box>
  );
}